import $ from 'jquery';
import EFOcats_event_birthday from '../../../core/v2/event/efocats_event_birthday';
import EFOcats_import_html from '../../../core/v2/import/efocats_import_html';

export default class EFOcats_iwatani_event_birthday extends EFOcats_event_birthday {
  event_select() {
    this.$('.qa.birthday-section select').on('change', event => {
      const element = event.currentTarget;
      const inputs = $(element).parents('.question').find('select');

      // 年と月に値がある場合だけ実行する
      if (!inputs.eq(0).val() || !inputs.eq(1).val()) {
        return;
      }
      // 日にちを覚えておく
      const day = inputs.eq(2).val();
      // 月末日計算
      const dt = new Date(inputs.eq(0).val(), inputs.eq(1).val(), 1);
      dt.setDate(dt.getDate() - 1);
      const lastday = dt.getDate();
      // 日にちの選択肢を再構築
      inputs.eq(2).empty();
      inputs.eq(2).append(EFOcats_import_html.getValue('select-question-option', {val: '', text: this.default_text}));
      for (let i = 1; i <= lastday; i++) {
        inputs.eq(2).append(EFOcats_import_html.getValue('select-question-option', {val: i, text: i}));
      }
      // 日にちを再選択
      inputs.eq(2).val(day);
      // ok-flagを外してエラーチェックが実行されるようにする
      if (!inputs.eq(2).val()) {
        inputs.eq(2).parents('.check-flag').removeClass('ok-flag');
      }
    });
  }
}
